import { render } from "./ClientNoteSaveDialog.vue?vue&type=template&id=48bea349&scoped=true"
import script from "./ClientNoteSaveDialog.vue?vue&type=script&lang=ts"
export * from "./ClientNoteSaveDialog.vue?vue&type=script&lang=ts"

import "./ClientNoteSaveDialog.vue?vue&type=style&index=0&id=48bea349&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48bea349"

export default script